import axios from "../../../axios";

export function getWelcomMessage(payload: any) {
  return axios.post(`/chat/api/chatbot-data/`, payload);
}
export function sendMessage(payload: any) {
  return axios.post(`/chat/user_query/`, payload);
}
